module.exports = __webpack_public_path__ + "assets/img/bannerBg2x.f947dba6.png";